import type {
  RunAgentMutation,
  RunAgentMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const RUN_AGENT: TypedDocumentNode<
  RunAgentMutation,
  RunAgentMutationVariables
> = gql`
  mutation RunAgent($id: String!) {
    runAgent(id: $id) {
      queued
      message
      taskName
      agent {
        id
        lastRunAt
        updatedAt
      }
    }
  }
`;
